const SearchAndFilterWithChildren = ({ component }: { component: JSX.Element }) => component;
SearchAndFilterWithChildren.displayName = 'SearchAndFilterWithChildren';

export default SearchAndFilterWithChildren;
